<template>
  <div>
    <breadcrumbs></breadcrumbs>
    <p class="title">消息中心</p>

    <div class="a1">
      <el-collapse
        v-for="(item, i) in arr"
        :key="i"
        @change="handleChange(item.messageRecId)"
      >
        <el-collapse-item>
          <template slot="title">
            <div class="add">
              <div class="a2" v-if="item.read == 0"></div>
              <div class="a2-a" v-if="item.read == 1"></div>
              <div class="a3">{{ item.title }}</div>
           </div>
           
           <!-- <div class="tat1">{{item.createTime}}</div> -->


          </template>
          <div v-html="item.content"></div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      arr: [],
    };
  },

  created() {
    this.getMessageList();
  },

  methods: {
    handleChange(id) {
      this.$api.activitymsg
        .batchRead({
          messageRecIds: id,
        })
        .then((e) => {
          // if (e.code==200) {
          //   this.content=content
          //   this.addORUpdateVisible1=true
          // }
        });
    },

    getMessageList() {
      this.$api.activitymsg
        .getMessageList({
          current: 1,
          size: 100,
        })
        .then((e) => {
          this.arr = e.data;
        });
    },
  },
};
</script>

<style scoped>

.tat1{

  /* margin-left: 20px; */
    /* display: flex;
  justify-content: flex-end;
    align-items: center;
    width: 90%; */
}


.a2-a {
  width: 8px;
  height: 8px;
  background: #d5d5d5;
  border-radius: 50%;
  opacity: 1;
}

.a3 {
  margin-left: 10px;
}

.add {
  display: flex;
  align-items: center;
  /* height: 100px; */
}
.a2 {
  width: 8px;
  height: 8px;
  background: #f34747;
  border-radius: 50%;
  opacity: 1;
}

.a1 {
  width: 90%;
  margin: auto;
}

.title {
  margin-top: 20px;
  width: 180px;
  height: 40px;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 40px;
  color: var(--text-main);
  opacity: 1;
}
</style>
